<template>
<v-data-table
    :headers="headers"
    :items="filteredItems"
    :search="search"
    :rows-per-page-items="rowsPerPageItems">
    <template v-slot:items="{ item }">
        <td>{{ item.AllowanceTypeName }}</td>
        <td>{{ item.Active ? 'Active' : 'Inactive' }}</td>
        <td>
            <v-btn color="primary" block @click="$emit('edit', item)">
                <span>Edit</span>
            </v-btn>
        </td>
    </template>
</v-data-table>
</template>

<script>
export default {
    props: {
        filteredItems: {
            type: Array,
            required: true
        },
        search: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            headers: [
                {
                    text: "Name",
                    value: "AllowanceTypeName",
                    sortable: true
                },
                {
                    text: "Active",
                    value: "Active",
                    sortable: true
                },
                {
                    text: "Edit",
                    sortable: false
                }
            ],
            rowsPerPageItems: [25, 50, 100, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]
        }
    }
}
</script>
